import React from 'react';
import error from '../../images/svg/err-2.webp'
const NotFound = () => {
    return (
        <div className='h-[100vh] mx-auto'>
            <img src={error} alt="" />
        </div>
    );
};

export default NotFound;